import { OnSiteLocationType, OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  header: 'Istoric comenzi',
  labels: {
    dummy_order: 'Comandă de test',
    orders_number: 'Număr de comenzi ({{count}})',
    revenue: 'Venituri: {{amount}}',
    tips: 'Bacșișuri: {{amount}}',
    cash_sales: ' ({{amount}} numerar)',
    refunds: 'Rambursări: {{count}} ({{amount}})',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Ridicare',
    [OrderMethod.Delivery]: 'Livrare',
    [OrderMethod.OnSite]: {
      [OnSiteLocationType.RoomService]: 'Room service',
      [OnSiteLocationType.TableService]: 'Serviciu la masă',
    },
  },
  statuses: {
    [OrderFulfillmentStatus.Created]: 'În curs',
    [OrderFulfillmentStatus.Reviewed]: 'În curs',
    [OrderFulfillmentStatus.Accepted]: 'În curs',
    [OrderFulfillmentStatus.Preparing]: 'În curs',
    [OrderFulfillmentStatus.Ready]: 'În curs',
    [OrderFulfillmentStatus.OnDelivery]: 'În curs',
    [OrderFulfillmentStatus.Picked]: 'Finalizat',
    [OrderFulfillmentStatus.Rejected]: 'Respins',
  },
  payment_methods: {
    invoice: 'Factură',
    cash: 'Numerar',
    online: 'Metodă online',
  },
  filters: {
    all: 'Toate',
  },
  fields: {
    order_placed: 'Comandă plasată',
    order_number: '#',
    customer: 'Client',
    payment_method: 'Metodă de plată',
    method: 'Tip',
    status: 'Stare',
    total: 'Total',
  },
  buttons: {
    print: 'Tipărire',
    create_test_order: 'Creare comandă de test',
  },
  toasts: {
    failed_to_fetch_orders:
      'Datele nu au putut fi încărcate. Faceți clic pe pictograma "reîmprospătare" sau încercați din nou după 1 minut.',
    something_went_wrong: 'Ceva nu a funcționat, vă rugăm încercați din nou.',
    failed_to_create_test_order: 'Comanda de test nu a putut fi creată',
    test_order_created: 'Comandă de test creată',
  },
};
